function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M511.816,410.239l-29-128c-0.826-3.647-4.069-6.235-7.808-6.232h-128c-3.606-0.002-6.768,2.41-7.72,5.888l-35,128 c-1.166,4.262,1.343,8.662,5.604,9.828c0.689,0.189,1.401,0.284,2.116,0.284h90.648c-3.083,27.31-26.164,47.962-53.648,48h-31 c-29.809-0.035-53.965-24.191-54-54v-330h102c3.672-0.001,6.871-2.501,7.76-6.064l10-40c1.069-4.287-1.539-8.629-5.826-9.698 c-0.633-0.158-1.282-0.238-1.934-0.238h-240c-4.418,0.001-7.999,3.584-7.998,8.002c0,0.652,0.08,1.301,0.238,1.934l10,40 c0.889,3.563,4.088,6.063,7.76,6.064h102v330c-0.035,29.809-24.191,53.965-54,54h-31c-27.484-0.038-50.565-20.69-53.648-48h90.648 c4.418,0.002,8.002-3.578,8.004-7.996c0-0.715-0.095-1.426-0.284-2.116l-35-128c-0.952-3.478-4.114-5.89-7.72-5.888h-128 c-3.739-0.003-6.982,2.585-7.808,6.232l-29,128c-0.976,4.309,1.725,8.594,6.034,9.57c0.582,0.132,1.177,0.198,1.774,0.198h85.304 c3.138,36.17,33.39,63.949,69.696,64h31c26.052-0.026,49.935-14.51,62-37.6c12.065,23.09,35.948,37.574,62,37.6h31 c36.306-0.051,66.558-27.83,69.696-64h85.304c4.418,0.003,8.003-3.576,8.006-7.994 C512.014,411.416,511.948,410.821,511.816,410.239z M18.024,404.007l25.376-112h115.496l30.624,112H18.024z M152.256,68.007l-6-24 H365.76l-6,24H152.256z M322.496,404.007l30.624-112h115.496l25.376,112H322.496z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg113(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.013 512.013",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg113);
export default __webpack_public_path__ + "static/media/1_13.1ec8dc78.svg";
export { ForwardRef as ReactComponent };